module.exports = __webpack_public_path__ + "static/media/S4N1-2.659cc739.svg";